/** Login popup (400x500 fixed panel). */
export const LOGIN_CSS = `
    .pw-login-popup {
      position: fixed;
      bottom: 140px;
      right: 25px;
      width: 400px;
      max-width: calc(100vw - 40px);
      height: 500px;
      max-height: calc(100vh - 100px);
      z-index: 2147483647;
      display: none;
      flex-direction: column;
      border-radius: 12px;
      border: 1.2px solid transparent;
      box-sizing: border-box;
      background:
        var(--pw-fill-panel) padding-box,
        linear-gradient(transparent, transparent) padding-box,
        var(--pw-border-gradient) border-box;
      box-shadow: var(--pw-shadow-dropdown);
      overflow: hidden;
      pointer-events: auto;
      font-family: var(--pw-font);
    }
    .pw-login-popup.visible {
      display: flex;
    }
    .pw-login-popup iframe {
      flex: 1;
      width: 100%;
      min-height: 0;
      border: none;
    }
    .pw-login-popup-close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 28px;
      height: 28px;
      z-index: 2;
      border-radius: 9999px;
      border: 1.2px solid transparent;
      background:
        var(--pw-fill-button) padding-box,
        linear-gradient(transparent, transparent) padding-box,
        var(--pw-border-gradient) border-box;
      box-shadow: var(--pw-shadow-rest);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      outline: none;
      padding: 0;
      color: var(--pw-text);
    }
    .pw-login-popup-close:hover {
      background:
        var(--pw-gradient-overlay) padding-box,
        var(--pw-fill-button) padding-box,
        var(--pw-border-gradient) border-box;
    }
    .pw-login-popup-close svg {
      width: 14px;
      height: 14px;
      display: block;
    }
    .pw-login-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      padding: 40px 32px;
      box-sizing: border-box;
      text-align: center;
    }
    .pw-login-card[hidden] {
      display: none !important;
    }
    .pw-login-card__title {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      color: var(--pw-text);
      font-family: var(--pw-font);
    }
    .pw-login-card__subtitle {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      color: var(--pw-text-muted, #6b7280);
      font-family: var(--pw-font);
    }
    .pw-login-card__cta {
      margin-top: 8px;
      min-width: 160px;
      height: 40px;
      padding: 0 20px;
      border-radius: 9999px;
      border: 1.2px solid transparent;
      background:
        var(--pw-fill-button) padding-box,
        linear-gradient(transparent, transparent) padding-box,
        var(--pw-border-gradient) border-box;
      box-shadow: var(--pw-shadow-rest);
      color: var(--pw-text);
      font-family: var(--pw-font);
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      outline: none;
    }
    .pw-login-card__cta:hover {
      background:
        var(--pw-gradient-overlay) padding-box,
        var(--pw-fill-button) padding-box,
        var(--pw-border-gradient) border-box;
    }
`;
